import { render, staticRenderFns } from "./QuestionMenu.vue?vue&type=template&id=435471db&scoped=true&lang=html&"
import script from "./QuestionMenu.vue?vue&type=script&lang=js&"
export * from "./QuestionMenu.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMenu.vue?vue&type=style&index=0&id=435471db&lang=less&rel=stylesheet%2Fless&scoped=true&"
import style1 from "./QuestionMenu.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435471db",
  null
  
)

export default component.exports